module.exports = __webpack_public_path__ + "img/questionnaire-yellow-circles.c0a7062e.svg";